import { makeRequest } from 'utils/requestLogger';

export const getLiveDiscussionCircle = (live_discussion_id) => {
  return makeRequest(
    'get',
    `/api/live_discussions/${live_discussion_id}/circle`
  );
};

export const tapIntoCircle = (live_discussion_id, turn_type) => {
  return makeRequest(
    'post',
    `/api/live_discussions/${live_discussion_id}/turns`,
    { turn_type }
  );
};

export const tapOutOfCircle = (live_discussion_id, user_id, participation_id, is_online) => {
  return makeRequest('post', `/api/live_discussions/${live_discussion_id}/turns/close`, { user_id, participation_id, is_online });
};

export const removeStudentFromCircle = (live_discussion_id, user_id, participation_id) => {
  return makeRequest(
    'post',
    `/api/live_discussions/${live_discussion_id}/turns/close-by-teacher`,
    { user_id, participation_id }
  );
};

export const addStudentToCircle = (live_discussion_id, user_id) => {
  return makeRequest(
    'post',
    `/api/live_discussions/${live_discussion_id}/turns/add-by-teacher`,
    { user_id }
  );
};

export const clearAllTapIns = (live_discussion_id, payload) => {
  return makeRequest(
    'post',
    `/api/live_discussions/${live_discussion_id}/turns/clear-all-tap-ins`, payload
  );
};

export const updateTurn = (turn_id, payload) => {
  return makeRequest('put', `/api/turns/${turn_id}`, payload);
};

export const teacherTapIn = (live_discussion_id, turn_type) => {
  return makeRequest(
    'post',
    `/api/live_discussions/${live_discussion_id}/teacher-tap-in`,
    { turn_type }
  );
};

export const teacherTapOut = (live_discussion_id) => {
  return makeRequest(
    'post',
    `/api/live_discussions/${live_discussion_id}/teacher-tap-out`
  );
};

export const studentDontSpeak = (live_discussion_id) => {
  return makeRequest(
    'post',
    `/api/live_discussions/${live_discussion_id}/student-dont-speak`
  );
};



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/circle/circleServices.js